import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { cartActions } from '../store/cart/cart.slice';
import { searchActions } from '../store/search/search.slice';
import { appActions } from '../store/app/app.slice';

const allActions = {
  ...cartActions,
  ...appActions,
  ...searchActions,
};

export const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(allActions, dispatch);
};
